import { apiEndpointsNavConfig } from './apiEndpoints';
import { cmsReferenceNavConfig } from './cmsReference';
import { uiComponentsNavConfig } from './uiComponents';

/**
 * The array of secondary nav configs for the `/api` section of the site.
 */
export default (() => [apiEndpointsNavConfig, cmsReferenceNavConfig, uiComponentsNavConfig]);